// frontend/src/features/bapb/modals/incomeApproachCatalog.js

export const INCOME_APPROACHES = [
  { type: "income",                   label: "Basic Income",               dataKey: "income" },
  { type: "income_advanced",          label: "Advanced Income",            dataKey: "income_advanced" },

  { type: "income_assessor",          label: "Basic Income (Assessor)",    dataKey: "income_assessor" },
  { type: "income_assessor_advanced", label: "Advanced Income (Assessor)", dataKey: "income_assessor_advanced" },

  { type: "income_actuals",           label: "Basic Income (Actuals)",     dataKey: "income_actuals" },
  { type: "income_actuals_advanced",  label: "Advanced Income (Actuals)",  dataKey: "income_actuals_advanced" },
];

// These keys are what we’ll use for hover-compare + modal “stat blocks”.
// They intentionally map to the MIRROR fields already stored by IncomeBasic/IncomeAdvanced.
export const INCOME_FIELD_DEFS = [
  { key: "income.potential_gross", label: "Potential Gross Income (PGI)" },
  { key: "income.vacancy",         label: "Vacancy / Credit Loss" },
  { key: "income.egi",             label: "Effective Gross Income (EGI)" },
  { key: "income.expenses",        label: "Operating Expenses" },
  { key: "income.noi",             label: "Net Operating Income (NOI)" },

  { key: "income.cap_rate",        label: "Cap Rate" },
  { key: "income.indicated_value", label: "Indicated Value" },

  { key: "income.deduction_applied", label: "Deduction Applied" },
  { key: "income.final_value",       label: "Final Value (after deduction)" },
];

function formatMoney(value) {
  const num = Number(String(value ?? "").replace(/[$,\s]/g, ""));
  if (!Number.isFinite(num)) return String(value ?? "");
  return `$${Math.round(num).toLocaleString()}`;
}

function pick(obj, ...keys) {
  for (const k of keys) {
    if (obj && obj[k] != null && String(obj[k]).trim() !== "") return obj[k];
  }
  return "";
}

// Given the inner income object (ex: draft.income.income), resolve a comparison field.
export function resolveIncomeCompareValue(incomeObj, key) {
  const o = incomeObj || {};

  switch (key) {
    case "income.potential_gross":
      return pick(o, "potential_gross", "pgi_total");

    case "income.vacancy":
      return pick(o, "vacancy");

    case "income.egi": {
	  // Most sections don't persist EGI as a top-level mirror, but they DO keep it in _calc.
	  // Use _calc.EGI first, then fall back to any persisted "egi" key if it exists.
	  const calc = o?._calc;
	  if (calc && calc.EGI != null && String(calc.EGI).trim() !== "") {
		return formatMoney(calc.EGI);
	  }
	  const persisted = pick(o, "egi");
	  return persisted === "" ? "" : formatMoney(persisted);
	}

    case "income.expenses":
      return pick(o, "expenses", "expenses_total");

    case "income.noi":
      return pick(o, "noi");

    case "income.cap_rate":
      return pick(o, "cap_rate", "base_cap_rate");

    case "income.indicated_value":
      return pick(o, "indicated_value");

    case "income.deduction_applied":
      return pick(o, "deduction_applied");

    case "income.final_value":
      return pick(o, "final_value");

    default:
      return "";
  }
}